module.exports = function() {
  return new Worker(__webpack_public_path__ + "43fcc096b90659c4865b.worker.js");
};